
import { useParams, Navigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ServiceImage from './components/ServiceImage';
import ServiceInfo from './components/ServiceInfo';
import ServiceDescription from './components/ServiceDescription';
import RelatedServices from './components/RelatedServices';
import { servicesData } from '../../mocks/services';
import SeoHead from '../../components/feature/SeoHead';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

export default function ServiceDetailPage() {
  const { serviceId } = useParams<{ serviceId: string }>();

  const service = servicesData.find(s => s.id === serviceId);

  if (!service) {
    return <Navigate to="/shop" replace />;
  }

  const serviceJsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: service.title,
      description: service.description,
      image: service.image,
      url: `${SITE_URL}/service/${service.id}`,
      brand: { '@type': 'Brand', name: 'VORENN TECH' },
      offers: {
        '@type': 'Offer',
        price: service.price,
        priceCurrency: 'USD',
        availability: 'https://schema.org/InStock',
        url: `${SITE_URL}/service/${service.id}`,
        seller: { '@type': 'Organization', name: 'VORENN TECH' },
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: 'Shop', item: `${SITE_URL}/shop` },
        { '@type': 'ListItem', position: 3, name: service.title, item: `${SITE_URL}/service/${service.id}` },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <SeoHead
        title={`${service.title} - Professional IT Service | VORENN TECH`}
        description={`${service.description} Starting at $${service.price}. Get expert ${service.title} from VORENN TECH.`}
        keywords={`${service.title}, ${service.category}, VORENN TECH, professional IT service`}
        canonical={`/service/${service.id}`}
        jsonLd={serviceJsonLd}
      />
      <Navbar />

      <main className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
            <ServiceImage image={service.image} title={service.title} />
            <ServiceInfo
              title={service.title}
              price={service.price}
              category={service.category}
            />
          </div>

          <ServiceDescription
            description={service.description}
            features={service.features}
          />

          <RelatedServices
            services={servicesData}
            currentServiceId={service.id}
          />
        </div>
      </main>

      <Footer />
    </div>
  );
}